import { render, staticRenderFns } from "./ProductVideo.vue?vue&type=template&id=4de4e789&scoped=true&"
import script from "./ProductVideo.vue?vue&type=script&lang=js&"
export * from "./ProductVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de4e789",
  null
  
)

export default component.exports